import {useFactorySlice} from "../useFactorySlice";
import {IFactory} from "../../../slices/FactorySlice";

export const useFactory = (factoryId?: string): IFactory | undefined => {
  const factorySlice = useFactorySlice();
  return factoryId ? factorySlice?.[factoryId] : undefined;
};
